export function init() {
  const form = document.getElementById('contact-form');
  const formStatus = document.getElementById('form-status');

  if (!form) return;

  form.addEventListener('submit', async e => {
    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    const btnChildren = Array.from(btn.childNodes).map(n => n.cloneNode(true));

    btn.disabled = true;
    btn.textContent = 'Sending...';
    btn.setAttribute('aria-busy', 'true');

    if (formStatus.textContent) {
      formStatus.className = 'form-status';
      formStatus.textContent = '';
    }

    try {
      const res = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });

      if (res.ok) {
        formStatus.className = 'form-status success';
        formStatus.textContent = "Message sent — I'll be in touch shortly.";
        form.reset();
      } else {
        const data = await res.json().catch(() => ({}));
        throw new Error(data?.errors?.[0]?.message ?? 'Submission failed');
      }
    } catch {
      formStatus.className = 'form-status error';
      formStatus.textContent = 'Something went wrong. Please try again or reach out on LinkedIn.';
    } finally {
      btn.disabled = false;
      btn.textContent = '';
      btnChildren.forEach(child => btn.appendChild(child));
      btn.setAttribute('aria-busy', 'false');
    }
  });
}
